import reduxPromiseListener from 'redux-promise-listener';

export const PROMISE_LISTENER = reduxPromiseListener();
